import * as Yup from "yup";

export const onboardingObject = {
  connectionID: "",
  brandID: "",
  connectionUrl: "",
  noDocker: false,
  token: "",
  fields: [],
  mappedFields: [],
  fieldNames: "",
  connection: false,
};

export function objectFromFormData(formData, mappedFields) {
  if (formData.noDocker) {
    return {
      brand_id: formData.brandID,
    };
  } else {
    let fieldMappings = {};
    for (let field of formData.fields) {
      if (field === undefined) {
        continue;
      }
      if (
        field !== undefined &&
        Object.values(field)[0] !== "" &&
        mappedFields[Object.keys(field)[0]] !== ""
      ) {
        fieldMappings[Object.keys(field)[0]] = Object.values(field)[0];
      } else if (
        field !== undefined &&
        Object.values(field)[0] === "" &&
        mappedFields[Object.keys(field)[0]] !== "" &&
        mappedFields[Object.keys(field)[0]] !== undefined
      ) {
        fieldMappings[Object.keys(field)[0]] = null;
      }
    }

    if (!formData.connectionID) {
      return {
        brand_id: formData.brandID,
        connectionDetails: {
          connection_url: formData.connectionUrl,
          token: formData.token,
        },
        fieldMappings: fieldMappings,
      };
    } else {
      return {
        brand_id: formData.brandID,
        connectionDetails: {
          connection_url: formData.connectionUrl,
          token: formData.token,
        },
        fieldMappings: fieldMappings,
      };
    }
  }
}

export function objectFromResponse(responseData, fieldsMapped) {
  let values = {};
  let fields = [];
  if (responseData.fieldMappings.length > 0) {
    for (let field of responseData.fieldMappings) {
      values[field.field_name] = field.field_value;
    }

    for (let field of fieldsMapped) {
      if (values[field.field_name] === undefined) {
        fields.push({ [field.field_name]: "" });
      } else {
        fields.push({ [field.field_name]: values[field.field_name] });
      }
    }
  }
  return {
    fields: fields,
    noDocker: responseData.connectionDetails.no_docker,
    mappedFields: values,
    brandDetails: responseData.brandDetails,
    fieldNames: responseData.fieldsNames || "",
    connection: responseData.connection || false,
    token: responseData.connectionDetails.token,
    brandID: responseData.connectionDetails.brand_id,
    connectionID: responseData.connectionDetails.connection_id,
    connectionUrl: responseData.connectionDetails.connection_url.replace(
      /\/$/,
      ""
    ),
  };
}

export const validationSchema = Yup.object().shape({
  brandID: Yup.string().required("Brand ID is required"),
  token: Yup.string()
    .matches(/(^[\w-]*\.[\w-]*\.[\w-]*$)/, "It must be a valid JWT token")
    .required("Token is required"),
  connectionUrl: Yup.string().matches(
    /(https?:\/\/)?(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.?)+[a-zA-Z]{2,}|(?:\d{1,3}\.){3}\d{1,3})(:\d{4})?(?:\/[\w\-._~:/?#[\]@!$&'()*+,;=%]*)?$/,
    "Enter correct url!"
  ),
});
